import React from 'react';
import PropTypes from 'prop-types';
import * as XLSX from 'xlsx';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  customFileInput: {
    display: 'none',
  },
}));

export default function ExcelFileUploader({ onDataChanged }) {
  const classes = useStyles();
  // const [isDragOver, setIsDragOver] = useState(false);

  const handleFileUpload = (file) => {
    const reader = new FileReader();

    reader.onload = (event) => {
      const binaryString = event.target.result;
      const workbook = XLSX.read(binaryString, { type: 'binary' });

      // Assuming the first sheet is the one you want to read
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];

      // Convert sheet data to array of objects
      const data = XLSX.utils.sheet_to_json(sheet, { header: 1 });

      // Assuming the first row contains headers
      const headers = data[0];
      const formattedData = data.filter((row) => row?.length > 0).slice(1).map((row) => {
        const rowData = {};
        headers.forEach((header, index) => {
          rowData[header] = row[index];
        });
        return rowData;
      });

      onDataChanged && onDataChanged({ file, data: formattedData });
    };

    reader.readAsBinaryString(file);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    // setIsDragOver(false);

    const file = e.dataTransfer.files[0];
    if (file) {
      handleFileUpload(file);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    // setIsDragOver(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    // setIsDragOver(false);
  };

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      handleFileUpload(file);
    }
  };

  return (
    <Box
      onDrop={handleDrop}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
    >
      <label htmlFor='fileInput'>
        <Button
          component="span"
          variant="contained"
          color="primary"
        >
          <CloudUploadIcon style={{ marginRight: 10 }} /> Excel檔案上傳
        </Button>
      </label>
      <input
        id='fileInput'
        className={classes.customFileInput}
        type='file'
        accept='.xlsx, .xls'
        onChange={handleFileSelect}
      />
    </Box>
  );
}

ExcelFileUploader.propTypes = {
  onDataChanged: PropTypes.func,
};
